import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { GraduationCap, Microscope, Award, BookOpen } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = () => {
    setIsLoading(true);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-purple-100 flex items-center justify-center p-4">
      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-8 items-center">
        {/* Left side - Branding */}
        <div className="space-y-6">
          <div className="flex items-center space-x-3">
            <div className="bg-gradient-to-br from-purple-600 to-purple-800 p-3 rounded-xl">
              <Microscope className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-purple-900">Tejeswi</h1>
              <p className="text-purple-600">Excellence in Chemistry</p>
            </div>
          </div>
          
          <h2 className="text-4xl font-bold text-gray-900">
            Welcome to the<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-700 to-purple-900">
              Learning Portal
            </span>
          </h2>
          
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <div className="bg-purple-100 p-2 rounded-lg flex-shrink-0">
                <Award className="h-5 w-5 text-purple-700" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">World-Class Education</h3>
                <p className="text-gray-600 text-sm">15+ World Toppers • 22+ Years Experience</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="bg-purple-100 p-2 rounded-lg flex-shrink-0">
                <BookOpen className="h-5 w-5 text-purple-700" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">IGCSE & CBSE Expertise</h3>
                <p className="text-gray-600 text-sm">Complete curriculum coverage for Grades 9-12</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="bg-purple-100 p-2 rounded-lg flex-shrink-0">
                <GraduationCap className="h-5 w-5 text-purple-700" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Personalized Learning</h3>
                <p className="text-gray-600 text-sm">Track your progress and access resources</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - Login Card */}
        <Card className="border-purple-200 shadow-2xl">
          <CardHeader className="text-center pb-8">
            <CardTitle className="text-2xl text-gray-900">Sign In to Continue</CardTitle>
            <CardDescription>
              Access your student portal or admin dashboard
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button 
              onClick={handleLogin}
              disabled={isLoading}
              size="lg"
              className="w-full bg-purple-700 hover:bg-purple-800 text-white py-6 text-lg"
            >
              {isLoading ? (
                <>
                  <span className="animate-spin mr-2">⏳</span>
                  Redirecting...
                </>
              ) : (
                <>
                  <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Continue with Google
                </>
              )}
            </Button>
            
            <p className="text-xs text-center text-gray-500">
              By continuing, you agree to our Terms of Service and Privacy Policy
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
